import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    tabsRoot: {
      "& .MuiTabs-scrollButtons": {
        background: "#fff",
        marginLeft: "-20px",
        width: "20px"
      },
      borderBottom: `1px solid ${theme.palette.divider}`,
      paddingLeft: theme.spacing(3)
    }
  }),
  { name: "OrderFilterTabs" }
);

interface FilterTabsProps {
  children?: React.ReactNode;
  currentTab: number;
}

export const OrderFilterTabs: React.FC<FilterTabsProps> = props => {
  const { children, currentTab } = props;

  const classes = useStyles(props);

  return (
    <Tabs
      className={classes.tabsRoot}
      value={currentTab}
      indicatorColor={"primary"}
      scrollButtons="on"
      variant="scrollable"
    >
      {children}
    </Tabs>
  );
};

export default OrderFilterTabs;
